<template>
  <div style="max-width: 1200px" v-if="champions.length">
    <h3>比赛复盘工具</h3>

    <div style="margin: 10px 0; padding: 20px; border-bottom: 1px solid #ccc">

      <div style="display: inline-block; width: 550px; margin-right: 20px; padding-left: 10px; border-left: 1px solid #ccc; vertical-align: top">

        <h4>Stat数据</h4>

        <template v-if="legs.stat">

          <p>GameId: {{ LegsStatReader.get_game_id(legs.stat) }}</p>
          <p>开始时间: {{ LegsStatReader.format_game_start_time(legs.stat) }}</p>
          <p>游戏时长: {{ LegsStatReader.format_game_duration(legs.stat) }}</p>
          <p>游戏版本: {{ LegsStatReader.get_game_version(legs.stat) }}</p>
          <p>游戏模式: {{ LegsStatReader.get_game_mode(legs.stat) }}</p>
          <p>游戏名称: {{ LegsStatReader.get_game_name(legs.stat) }}</p>
          <p>服务器: {{ LegsStatReader.get_game_server_name(legs.stat) }}</p>

          <div style="margin: 10px 0">
            <p>蓝色方阵容:</p>
            <div v-for="player in blue_team_players" style="display: inline-block; width: 100px; text-align: center; margin: 0 auto">
              <img :src="dragontail.generate_champion_logo_url_with_id(player.championId, champions)" style="width: 60px; height: 60px">
              <div>{{ player.summonerName }}</div>
              <div>{{ "" + player.kills + "/" + player.deaths + "/" + player.assists }}</div>
              <div>{{ player.originalAccountId }}</div>
            </div>
          </div>

          <div style="margin: 10px 0">
            <p>红色方阵容:</p>
            <div v-for="player in red_team_players" style="display: inline-block; width: 100px; text-align: center; margin: 0 auto">
              <img :src="dragontail.generate_champion_logo_url_with_id(player.championId, champions)" style="width: 60px; height: 60px">
              <div>{{ player.summonerName }}</div>
              <div>{{ "" + player.kills + "/" + player.deaths + "/" + player.assists }}</div>
              <div>{{ player.originalAccountId }}</div>
            </div>
          </div>

          <p>
            <a href="javascript:;" @click="delete_legs()" style="margin-right: 5px">重置</a>
          </p>

        </template>
        <template v-else>
          <p>
            <a href="javascript:;" @click="trigger_click('legStat')" style="margin-right: 5px">选择本地文件</a>
          </p>

          <p>
            <a href="javascript:;" @click="copy_from_clipboard('stat')" style="margin-right: 5px" >读取剪贴板</a>
          </p>
        </template>

      </div>

      <div style="display: inline-block; width: 550px; margin-left: 20px; padding-left: 10px; border-left: 1px solid #ccc; vertical-align: top">

        <h4>Timeline数据</h4>

        <template v-if="legs.timeline">

          <p>记录间隔: {{ LegsTimelineReader.get_frame_interval(legs.timeline) }}秒</p>
          <p>记录数: {{ game_frames.length }}条</p>
          <p>事件数: {{ game_events.length }}个</p>

          <p>
            <a href="javascript:;" @click="delete_legs()" style="margin-right: 5px">重置</a>
          </p>

        </template>
        <template v-else>
          <p>
            <a href="javascript:;" @click="trigger_click('legTimeline')" style="margin-right: 5px">选择本地文件</a>
          </p>

          <p>
            <a href="javascript:;" @click="copy_from_clipboard('timeline')" style="margin-right: 5px" >读取剪贴板</a>
          </p>
        </template>
      </div>
    </div>

    <div class="clearfix" style="margin: 20px 0" v-show="replayReady">
      
      <div class="tp_container">
        <div>
          <div class="tp_map" :current_ward_types="current_ward_types">
            <img class="tp_map_img" src="" :src="static_url('/img/wordmap.jpg')">

            <div class="tp_echart_wrap">
              <div ref="echart_instance" style="height:700px;width:700px;position:relative"></div>
            </div>

            <div class="tp_game_score_line" :style="'background:url(' + static_url('/img/game_review/match_info_bg.png') + ')'" v-if="gameInfo">
              <div class="tp_team_name tp_blue_team_name">{{ gameInfo.teams.blue_team }}</div>

              <div class="tp_tower tp_tower_blue">
                <img class="tp_tower_img" :src="static_url('/img/game_review/tower_icon.png')">
                <span class="tp_tower_num">{{ current_score.blue_team.tower }}</span>
              </div>

              <div class="tp_gold tp_gold_blue">
                <img class="tp_gold_img" :src="static_url('/img/game_review/coin_icon.png')">
                <span class="tp_gold_num">{{ format_team_gold(current_score.blue_team.gold) }}</span>
              </div>

              <div class="tp_game_score">
                <span class="tp_score_blue">{{ current_score.blue_team.kill }}</span>
                <img class="tp_score_img" :src="static_url('/img/game_review/kill_icon.png')">
                <span class="tp_score_red">{{ current_score.red_team.kill }}</span>
              </div>

              <div class="tp_gold tp_gold_red">
                <img class="tp_gold_img" :src="static_url('/img/game_review/coin_icon.png')">
                <span class="tp_gold_num">{{ format_team_gold(current_score.red_team.gold) }}</span>
              </div>

              <div class="tp_tower tp_tower_red">
                <img class="tp_tower_img" :src="static_url('/img/game_review/tower_icon.png')">
                <span class="tp_tower_num">{{ current_score.red_team.tower }}</span>
              </div>

              <div class="tp_team_name tp_red_team_name">{{ this.gameInfo.teams.red_team }}</div>
            </div>

            <div class="tp_dragons_blue" v-show="current_score.blue_team.dragons.length">
              <img v-for="dragonImg in current_score.blue_team.dragons" class="tp_dragon_img" :src="dragonImg" />
            </div>

            <div class="tp_dragons_red" v-show="current_score.red_team.dragons.length">
              <img v-for="dragonImg in current_score.red_team.dragons" class="tp_dragon_img" :src="dragonImg" />
            </div>

            <div class="tp_game_time">{{ format_game_time(this.timeline.current) }}</div>

            <div class="tp_loading_wrap" v-show="app_is_loading">
              <div class="tp_centerbox">
                <div v-show="!app_loading_error">
                  <img :src="static_url('/img/loading_gif.gif')">
                </div>
                <div v-show="app_loading_error">
                  <p style="color: yellow;text-align: center;margin-top: 20px;font-size: 20px; line-height: 150%">{{ app_loading_error }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="slider-box">
            <div class="tp_item" style="left: 12px; top: 8px;">
              <i class="fa fa-pause play-btn" v-if="autoPlay" @click="switch_auto_play()"></i>
              <i class="fa fa-play play-btn" v-if="!autoPlay" @click="switch_auto_play()"></i>
            </div>
            <div ref="timeline" class="tp_timeline">
            </div>
            <div class="tp_item" style="right: 6px">
              <span style="color: #fff;"> <span style="color: #ff9300">{{ format_game_time(this.timeline.current) }}</span> / {{ format_game_time(this.timeline.total) }}</span>
            </div>
          </div>

        </div>

      </div>



      <div class="clearfix"></div>

    </div>

    <div style="display: none">
      <input type="file" ref="legStat"
        @change="update_legs('legStat', 'stat')" multiple />

      <input type="file" ref="legTimeline"
        @change="update_legs('legTimeline', 'timeline')" multiple />
    </div>

    <script type="text/html" ref="tooltipTpl">
      <div style="position: relative; width: 175px;color: white;">
        <div style="width: 45px; float: left">
          <img src="<%=logo%>" style="width: 40px; height: 40px; border-radius: 50%; border: solid 2px black; border-color: <%=color%>" />
        </div>
        <div style="width: 130px; float: right">
          <div style="width: 130px; font-weight: bold; color: <%= color %>"><%=title%></div>
          <div style="width: 130px; color: #AAAAAA; white-space: pre-wrap; font-size: 12px"><%=content%></div>
        </div>
        <div style="clear: both"></div>
      </div>
    </script>

  </div>
</template>


<script>

import lodash from "lodash"
import LegsStatReader from "@/utils/legs_stat_reader"
import LegsTimelineReader from "@/utils/legs_timeline_reader"
import GameReplayDataLoader from "@/utils/game_replay_data_loader"
import dragontail from "@/utils/dragontail"

import echarts from 'echarts'
import axios from 'axios';
import template from 'template_js';

// 节流器配置
var throttleLast;
var throttleTimer;

var playerInterval;

var autoPlayerPause = false
var pauseTimer;

export default {
  props: {
    config: {
      type: Object,
      default: () => ({
        warn_message: "props.config not set"
      })
    }
  },
  data: function(){
    return {
      name: "jeffrey",
      legs: {
        stat: null,
        timeline: null
      },
      champions: [],
      timeline: {
        total: 3600,
        current: 60,
        data: [
          {
            time: "00:00",
            style: "left: 0",
          },
          {
            time: "60:00",
            style: "right: 0"
          }
        ]
      },
      echart_instance: null,
      isLoadingGameInfo: false,
      gameInfoLoadingError: "",
      gameInfo: this.generateDefaultGameInfo(),
      settings: this.loadSettings(),
      autoPlay: true,
      current_ward_types: ["YELLOW_TRINKET", "BLUE_TRINKET", "SIGHT_WARD", "CONTROL_WARD", "UNDEFINED"],
      all_ward_types: [
        {
          cn_title: "饰品眼",
          en_title: "Yellow Trinket",
          value: "YELLOW_TRINKET"
        },
        {
          cn_title: "远见改造",
          en_title: "Blue Trinket",
          value: "BLUE_TRINKET"
        },
        {
          cn_title: "装备眼",
          en_title: "Sight Ward",
          value: "SIGHT_WARD"
        },
        {
          cn_title: "控制守卫",
          en_title: "Control Ward",
          value: "CONTROL_WARD"
        },
        {
          cn_title: "未知眼",
          en_title: "Underfined",
          value: "UNDEFINED"
        }
      ],
    }
  },
  mounted: function(){

    this.init()

    // 绑定键盘事件
    if(window && window.document){
      window.document.onkeydown = this.handle_keyboard
    }

    this.autoPlayerWatcher(this.autoPlay)
  },
  updated: function(){

    // console.log("updated")

    var thisApp = this;

    thisApp.draw_timeline();

    var now = +new Date()

    var threshhold = 100

    var delayTime

    if(throttleLast){
      delayTime = (throttleLast + threshhold) - now
    }else{
      delayTime = 0
    }

    if(delayTime > 0){

      clearTimeout(throttleTimer);

      throttleTimer = setTimeout(function () {
        throttleLast = now
        thisApp.nextTickDrawEcharts();
      }, delayTime);
    }else{
      throttleLast = now
      thisApp.nextTickDrawEcharts();
    }

  },
  watch: {
    autoPlay: function(value, oldValue){
      this.autoPlayerWatcher(value)
    },
    replayReady: function(value, oldValue){

      if(value == true){

        //开启比赛复盘
        this.import_game_info()

      }else{
        //关闭比赛复盘
        this.gameInfo = this.generateDefaultGameInfo()
      }
    }
  },
  computed: {
    LegsStatReader: function(){
      return LegsStatReader
    },
    LegsTimelineReader: function(){
      return LegsTimelineReader
    },
    dragontail: function(){
      return dragontail
    },
    game_players: function(){
      if(!this.legs.stat){
        return []
      }

      return LegsStatReader.get_game_players(this.legs.stat)
    },
    game_frames: function(){
      if(!this.legs.timeline){
        return
      }

      return LegsTimelineReader.get_all_frames(this.legs.timeline)
    },
    game_events: function(){
      if(!this.legs.timeline){
        return
      }

      return LegsTimelineReader.get_all_events(this.legs.timeline)
    },
    replayReady: function(){
      return !!this.legs.stat && !!this.legs.timeline
    },
    blue_team_players: function(){
      return lodash.filter(this.game_players, function(player){
        return player.teamId == 100
      })
    },
    red_team_players: function(){
      return lodash.filter(this.game_players, function(player){
        return player.teamId == 200
      })
    },
    playSpeed(){
      return this.settings.playSpeed
    },
    current_score(){
      var thisApp = this;

      var blueTeam = {
        kill: 0,
        gold: 0,
        tower: 0,
        dragons: []
      }

      var redTeam = {
        kill: 0,
        gold: 0,
        tower: 0,
        dragons: []
      }

      // 汇总击杀
      var heroKillEvents = lodash.filter(thisApp.gameInfo.heroKillEvents, function(event){
        return parseInt(event.event_time / 1000) <= thisApp.timeline.current
      })

      heroKillEvents.forEach(function(event){
        if(event.victim_team_id === thisApp.gameInfo.teams.blue_team_id){
          redTeam.kill += 1
        }else if(event.victim_team_id === thisApp.gameInfo.teams.red_team_id){
          blueTeam.kill += 1
        }
      })

      // 汇总推塔
      thisApp.gameInfo.buildings.forEach(function(building){

        if(building.building_type != "TOWER_BUILDING"){
          return
        }

        var buildingFrame = lodash.findLast(building.timeline, function(frame){
          return frame.time <= thisApp.timeline.current
        })

        if(buildingFrame && buildingFrame.status==="dead"){
          if(building.team === "blue"){
            redTeam.tower += 1
          }else{
            blueTeam.tower += 1
          }
        }

      })

      // 汇总经济
      var blueTeamGoldFrame = lodash.findLast(thisApp.gameInfo.teams.blue_team_gold_timeline, function(frame){
        return frame.time <= thisApp.timeline.current
      })
      if(blueTeamGoldFrame){
        blueTeam.gold = blueTeamGoldFrame.gold
      }

      var redTeamGoldFrame = lodash.findLast(thisApp.gameInfo.teams.red_team_gold_timeline, function(frame){
        return frame.time <= thisApp.timeline.current
      })
      if(redTeamGoldFrame){
        redTeam.gold = redTeamGoldFrame.gold
      }

      // 汇总龙
      var dragonData = lodash.find(thisApp.gameInfo.monsters, function(monster){
        return monster.key === "DRAGON"
      })

      if(dragonData){

        var dragonTimeline = lodash.filter(dragonData.timeline, function(frame){
          return frame.time <= thisApp.timeline.current
        })

        dragonTimeline.forEach(function(frame){
          if(frame.status==="dead" && frame.sub_type != "ELDER_DRAGON"){
            if(frame.killer_team_id === thisApp.gameInfo.teams.blue_team_id){
              blueTeam.dragons.push(thisApp.dragon_img_url(frame.sub_type))
            }else if(frame.killer_team_id === thisApp.gameInfo.teams.red_team_id){
              redTeam.dragons.push(thisApp.dragon_img_url(frame.sub_type))
            }
          }
        })
      }


      var score = {
        blue_team: blueTeam,
        red_team: redTeam
      }

      return score
    },
    playerId_to_heroId(){
      var dict = {}
      this.gameInfo.players.forEach(function(player){
        dict[player.player_id] = player.hero_id
      })

      return dict
    },
    playerId_to_teamId(){
      var dict = {}
      this.gameInfo.players.forEach(function(player){
        dict[player.player_id] = player.team_id
      })

      return dict
    },
    current_hero_positions(){

      var thisApp = this
      var retPositions = []

      var currentTime = this.timeline.current;

      this.gameInfo.heroPositions.forEach(function(heroPosition){

        var playerInfo = lodash.find(thisApp.gameInfo.players, function(player){
          return player.hero_id === heroPosition.hero_id
        })

        if(playerInfo && heroPosition.interval && heroPosition.hot_point){

          var posIndex = parseInt(currentTime / heroPosition.interval)

          if(posIndex >= heroPosition.hot_point.length){
            posIndex = heroPosition.hot_point.length - 1
          }

          var posInfo = heroPosition.hot_point[posIndex]

          if(posInfo){

            var posTime = posIndex * heroPosition.interval

            var retPosition = lodash.merge({}, playerInfo)

            // 计算出中间点位置，假设选手在两点间做匀速直线运动
            var nextPosIndex = posIndex + 1
            var nextPos = heroPosition.hot_point[nextPosIndex]
            if(nextPos){

              var nextPosTime = nextPosIndex * heroPosition.interval
              var multiple = (currentTime - posTime) / (nextPosTime - posTime)

              retPosition.point_x = posInfo.axis_x + (nextPos.axis_x - posInfo.axis_x) * multiple
              retPosition.point_y = posInfo.axis_y + (nextPos.axis_y - posInfo.axis_y) * multiple
              retPosition.pos_time = currentTime
            }else{
              retPosition.point_x = posInfo.axis_x
              retPosition.point_y = posInfo.axis_y
              retPosition.pos_time = posTime
            }

            retPositions.push(retPosition)
          }
        }
      })

      return retPositions
    },
    current_line_heros(){

      var thisApp = this
      var retHeros = []

      var currentTime = this.timeline.current;

      this.gameInfo.heroPositions.forEach(function(heroPosition){

        var playerInfo = lodash.find(thisApp.gameInfo.players, function(player){
          return player.hero_id === heroPosition.hero_id
        })

        if(playerInfo && heroPosition.interval && heroPosition.hot_point){


          var posIndex = parseInt(currentTime / heroPosition.interval)

          if(posIndex >= heroPosition.hot_point.length){
            posIndex = heroPosition.hot_point.length - 1
          }

          var retHero = lodash.merge({}, playerInfo)

          var historyPoints = []
          var futurePoints = []
          var historyStep = parseInt(retHero.history_step)
          var futureStep = parseInt(retHero.future_step)

          if(historyStep > 0){
            for(var offset = historyStep * -1; offset <= 0; offset++){
              var posInfo = heroPosition.hot_point[posIndex + offset]
              if(posInfo){
                historyPoints.push([posInfo.axis_x, posInfo.axis_y])
              }
            }
          }

          if(futureStep > 0){
            for(var offset = 0; offset <= futureStep; offset++){
              var posInfo = heroPosition.hot_point[posIndex + offset]
              if(posInfo){
                futurePoints.push([posInfo.axis_x, posInfo.axis_y])
              }
            }
          }

          retHero.history_points = historyPoints
          retHero.future_points = futurePoints
          retHeros.push(retHero)
        }
      })

      return retHeros
    },
    alive_wards(){
      var thisApp = this;

      var aliveWards = []

      var currentTime = thisApp.timeline.current

      this.gameInfo.wards.forEach(function(ward){


        var tmpIndex = lodash.sortedLastIndexBy(ward.timeline, { 'time': currentTime }, 'time');
        var wardFrame = ward.timeline[tmpIndex - 1]

        var isAlive = wardFrame ? wardFrame.status==="alive" : false

        if(isAlive){
          aliveWards.push(ward)
        }
      })

      return aliveWards
    },
    alive_buildings(){

      var thisApp = this;

      var aliveBuildings = []

      var currentTime = thisApp.timeline.current

      this.gameInfo.buildings.forEach(function(building){

         var tmpIndex = lodash.sortedLastIndexBy(building.timeline, { 'time': currentTime }, 'time');
         var buildingFrame = building.timeline[tmpIndex - 1]

        //var buildingFrame = lodash.findLast(building.timeline, function(frame){
        //  return currentTime >= frame.time
        //})

        var isAlive = buildingFrame ? buildingFrame.status==="alive" : false

        if(isAlive){
          aliveBuildings.push(building)
        }
      })

      return aliveBuildings
    },
    alive_monsters(){
      var thisApp = this

      var aliveMonsters = []

      var currentTime = thisApp.timeline.current

      this.gameInfo.monsters.forEach(function(monster){

         var tmpIndex = lodash.sortedLastIndexBy(monster.timeline, { 'time': currentTime }, 'time');
         var monsterFrame = monster.timeline[tmpIndex - 1]

        //var monsterFrame = lodash.findLast(monster.timeline, function(frame){
        //  return currentTime >= frame.time
        //})

        var isAlive = monsterFrame ? monsterFrame.status==="alive" : false

        if(isAlive){
          aliveMonsters.push(monster)
        }
      })

      return aliveMonsters
    },
    app_is_loading(){
      return this.isLoadingGameInfo
    },
    app_loading_error(){
      return this.gameInfoLoadingError
    }
  },
  methods: {
    init: async function(){
      
      this.champions = await dragontail.async_get_or_fetch_champions()

    },
    trigger_click: function(inputRef){
      this.$refs[inputRef].click()
    },
    update_legs: function(inputRef, name) {

      var thisApp = this

      const inputDom = thisApp.$refs[inputRef]

      const files = inputDom.files
      const file = files[0]

      if(!file){
        thisApp.legs[name] = null
        return
      }

      var reader = new FileReader();
      reader.onload = function (e) {

        var fileContent = e.target.result

        inputDom.value = ""

        var loadData

        try {
          loadData = JSON.parse(fileContent)
        } catch (e) {
          loadData = null
        }

        var source

        if(loadData){
          if(name == "stat"){
            source = LegsStatReader.get_source(loadData)
          }else if(name == "timeline"){
            source = LegsTimelineReader.get_source(loadData)
          }
        }

        if(!source){
          alert("发生错误，数据无法正确解析")
          return
        }

        thisApp.legs[name] = loadData
      };
      reader.readAsText(file);
    },
    delete_legs: function(){
      this.legs.stat = null
      this.legs.timeline = null
    },
    copy_from_clipboard: async function(name){

      var text = await navigator.clipboard.readText()

      if(!text){
        alert("未读取到内容")
        return
      }

      var loadData

      try {
        loadData = JSON.parse(text)
      } catch (e) {
        loadData = null
      }

      var source

      if(loadData){
        if(name == "stat"){
          source = LegsStatReader.get_source(loadData)
        }else if(name == "timeline"){
          source = LegsTimelineReader.get_source(loadData)
        }
      }

      if(!source){
        alert("发生错误，数据无法正确解析")
        return
      }

      this.legs[name] = loadData

      return true
    },
    autoPlayerWatcher: function(newValue){

      var thisApp = this

      thisApp.autoPlay = newValue

      if(playerInterval){
        clearInterval(playerInterval)
      }

      if(thisApp.autoPlay){
        playerInterval = setInterval(function(){

          if(autoPlayerPause){
            return
          }

          if(thisApp.timeline.current < thisApp.gameInfo.duration){

            var newCurrent = thisApp.timeline.current + 1

            if(newCurrent < thisApp.gameInfo.duration){
              thisApp.timeline.current = newCurrent
            }else{
              thisApp.timeline.current = thisApp.gameInfo.duration
            }
          }

        }, 1000 / parseFloat(thisApp.playSpeed));
      }

    },
    nextTickDrawEcharts(){

      var thisApp = this

      thisApp.$nextTick(function(){
        thisApp.draw_echarts();
      })
    },
    handle_keyboard(){

      var keycode = event.which;
      if(keycode === 32){
        // 空格事件
        this.switch_auto_play()

        event.preventDefault();
      }
      if(keycode === 37){
        // 左方向键
        var nextTime = this.timeline.current - 5
        if(nextTime < 0){
          nextTime = 0
        }

        this.temp_pause_player()

        this.timeline.current = nextTime

        event.preventDefault();
      }
      if(keycode === 39){
        // 右方向键
        var nextTime = this.timeline.current + 5
        if(nextTime > this.timeline.total){
          nextTime = this.timeline.total
        }

        this.temp_pause_player()

        this.timeline.current = nextTime

        event.preventDefault();
      }

      // var realkey = String.fromCharCode(keycode);
      // console.log("按键码: " + keycode + " 字符: " + realkey);

    },
    dragon_img_url(dragonType){
      if(dragonType==="FIRE_DRAGON"){
        return this.static_url('/img/game_review/fire_dragon_icon.png')
      }else if(dragonType==="WATER_DRAGON"){
        return this.static_url('/img/game_review/water_dragon_icon.png')
      }else if(dragonType==="EARTH_DRAGON"){
        return this.static_url('/img/game_review/earth_dragon_icon.png')
      }else if(dragonType==="AIR_DRAGON"){
        return this.static_url('/img/game_review/air_dragon_icon.png')
      } if(dragonType==="ELDER_DRAGON"){
        return this.static_url('/img/game_review/elder_dragon_icon.png')
      }else{
        return this.static_url('/img/game_review/zb_dragon_icon.png')
      }
    },
    format_team_gold(gold){

      var num = lodash.floor(lodash.divide(gold, 1000.0), 1)

      var zeroTail = num % 1 === 0 ? ".0" : ""

      return "" + num + zeroTail + "k"
    },
    switch_auto_play(){
      if(this.autoPlay){
        this.autoPlay = false
      }else{
        this.autoPlay = true
      }
      return this.autoPlay
    },
    format_eye_type(type){
      var hiEyeType = lodash.find(this.all_ward_types, function(eyeType){
        return eyeType.value === type
      })
      if(hiEyeType){
        return this.settings.language=="en" ? hiEyeType.en_title : hiEyeType.cn_title
      }else{
        return this.settings.language=="en" ? "Underfined" : "未知眼"
      }
    },
    init_echart_instance(){
      if(!this.echart_instance){
        this.echart_instance = echarts.init(this.$refs.echart_instance)
      }
      return this.echart_instance
    },
    draw_echarts(){

      var thisApp = this

      var max = {
        x: 14870,
        y: 14980
      }
      var min = {
        x: -120,
        y: -120
      }

      var echartSeries = []

      var lineData = []
      var scatterData = []

      // 塔
      thisApp.alive_buildings.forEach(function(building){

        var obj = {}
        obj.name = "building_" + building.point_x + "_" + building.point_y
        obj.value = [building.point_x, building.point_y]
        obj.symbol = "image://" + building.logo_url
        obj.type = "building"
        obj.symbolSize = 24
        obj.hover_tips = null
        obj.animation = false

        var destroyFrame = lodash.findLast(building.timeline, function(frame){
          return frame.status === "dead"
        })

        var tipContent
        if(destroyFrame){
          tipContent = "在 " + thisApp.format_game_time(destroyFrame.time) + " 时被摧毁"
        }else{
          tipContent = "未被摧毁"
        }

        obj.tooltipData = {
          logo: building.logo_url,
          color: thisApp.get_team_color(building.team),
          title: building.name,
          content: tipContent
        }

        obj.tooltip = {
          formatter: function(params){
            if(!params.data.tooltipData){
              return
            }

            return thisApp.generateCommonToolTipHtml(params.data.tooltipData)
          },
          position: function (point, params, dom, rect, size) {
            return "top"
          },
          backgroundColor: 'rgba(0,0,0,0.8)'
        }

        scatterData.push(obj)
      })

      // 眼
      var currentWardTypes = new Set(this.current_ward_types);

      thisApp.alive_wards.forEach(function(ward){

        // 是否包含在所选眼位类型里
        if(!currentWardTypes.has(ward.eye_type)){
          return false
        }

        var obj = {}
        obj.name = "ward_" + ward.eye_id
        obj.value = [ward.point_x, ward.point_y]
        obj.symbol = "image://" + ward.logo_url
        obj.type = "ward"

        obj.born_color = ward.born_color
        obj.hero_logo = ward.hero_logo
        obj.player_name = ward.player
        obj.event_time = thisApp.format_game_time(ward.event_time / 1000)
        obj.wards_name = thisApp.format_eye_type(ward.eye_type)

        obj.tooltip = {
          formatter: function (params) {
            return thisApp.generateWardToolTipHtml(params.data)
          },
          position: function (point, params, dom, rect, size) {
            return "top"
          },
          backgroundColor: 'rgba(0,0,0,0.8)'
        }


        scatterData.push(obj)
      })

      // 英雄当前位置
      thisApp.current_hero_positions.forEach(function(heroPos){

        var heroFrame = lodash.findLast(heroPos.timeline, function(frame){
          return frame.time <= heroPos.pos_time
        })

        var isAlive = heroFrame ? heroFrame.status==="alive" : true

        var teamColor
        if(heroPos.born_color===1){
          teamColor = thisApp.get_team_color("blue");
        }else{
          teamColor = thisApp.get_team_color("red");
        }

        var objColor
        if(isAlive){
          objColor = teamColor
        }else{
          objColor = "black"
        }

        var playerName = "" + heroPos.team_name + " " + heroPos.game_name

        var obj = {}
        obj.name = "hero_" + heroPos.hero_id
        obj.value = [heroPos.point_x, heroPos.point_y]
        obj.type = "hero"
        obj.player_name = playerName
        obj.born_color = heroPos.born_color
        obj.hero_logo = heroPos.hero_logo
        obj.symbolSize = 24
        obj.symbol = "circle"

        obj.itemStyle = {
          color: objColor
        }

        obj.label = {
          show: true,
          name: "hero_label_" + heroPos.hero_id,
          width: 24,
          height: 24,
          formatter: ["{logo|}"].join('\n'),
          rich: {
            logo: {
              width: 24,
              height: 24,
              borderRadius: 12,
              borderWidth: 3,
              borderColor: objColor,
              backgroundColor: {
                image: heroPos.circle_logo
              }
            }
          }
        }

        var nextDeadFrame = lodash.find(heroPos.timeline, function(frame){
          return frame.time >= thisApp.timeline.current && frame.status === "dead"
        })

        var tipContent
        if(nextDeadFrame){
          if(nextDeadFrame.killer_name){
            tipContent = "在" + thisApp.format_game_time(nextDeadFrame.time) + "时被" + nextDeadFrame.killer_name + "击杀"
          }else{
            tipContent = "在" + thisApp.format_game_time(nextDeadFrame.time) + "时死亡"
          }
        }else{
          tipContent = "未再死亡"
        }

        obj.tooltipData = {
          logo: heroPos.hero_logo,
          color: teamColor,
          title: playerName,
          content: tipContent
        }

        obj.tooltip = {
          formatter: function(params){
            if(!params.data.tooltipData){
              return
            }

            return thisApp.generateCommonToolTipHtml(params.data.tooltipData)
          },
          position: function (point, params, dom, rect, size) {
            return "top"
          },
          backgroundColor: 'rgba(0,0,0,0.8)'
        }


        scatterData.push(obj)
      })

      // 野怪
      thisApp.alive_monsters.forEach(function(monster){

        var tipContent
        var monsterLogo = monster.logo_url

        var killFrame = lodash.find(monster.timeline, function(frame){
          return frame.time >= thisApp.timeline.current && frame.status === "dead" && !frame.auto_disappear
        })
        if(killFrame){
          tipContent = "在" + thisApp.format_game_time(killFrame.time) + "时被" + killFrame.killer_name + "击杀"
          if(killFrame.sub_type){
            monsterLogo = thisApp.dragon_img_url(killFrame.sub_type)
          }
        }else{
          tipContent = "未被击杀"
        }

        var obj = {}
        obj.name = monster.key,
        obj.value = [monster.point_x, monster.point_y]
        obj.symbol = "image://" + monsterLogo
        obj.type = "monster"

        if(monster.key==="DRAGON" || monster.key==="BARON_NASHOR" || monster.key==="RIFTHERALD"){
          obj.symbolSize = 30
        }else{
          obj.symbolSize = 16
        }


        obj.tooltipData = {
          logo: monsterLogo,
          color: "orange",
          title: monster.name,
          content: tipContent
        }

        obj.tooltip = {
          formatter: function(params){
            if(!params.data.tooltipData){
              return
            }

            return thisApp.generateCommonToolTipHtml(params.data.tooltipData)
          },
          position: function (point, params, dom, rect, size) {
            return "top"
          },
          backgroundColor: 'rgba(0,0,0,0.8)'
        }

        scatterData.push(obj)
      })

      // 英雄走位Line
      var lineHeros = thisApp.current_line_heros

      lineHeros.forEach(function(lineHero){

        // 历史走位
        if(lineHero.history_points.length > 1){

          var color

          if(lineHero.born_color===1){
            color = thisApp.get_team_color("blue");
          }else{
            color = thisApp.get_team_color("red");
          }

          echartSeries.push({
            name: "histroy_line_" + lineHero.hero_id,
            type: 'line',
            symbol: 'circle',
            symbolSize: 4,
            smooth: false,
            hoverAnimation: false,
            itemStyle: {
              color: "grey"
            },
            lineStyle: {
              color: "grey",
              type: "dotted",
              opacity: 0.5
            },
            tooltip: {
              formatter: function(params){
                return
              }
            },
            data: lineHero.history_points
          })
        }

        // 未来走位
        if(lineHero.future_points.length > 1){

          var color

          if(lineHero.born_color===1){
            color = thisApp.get_team_color("blue");
          }else{
            color = thisApp.get_team_color("red");
          }

          echartSeries.push({
            name: "future_line_" + lineHero.hero_id,
            type: 'line',
            symbol: 'circle',
            symbolSize: 4,
            smooth: false,
            hoverAnimation: false,
            itemStyle: {
              color: color
            },
            lineStyle: {
              color: color,
              type: "dotted",
              opacity: 0.5
            },
            tooltip: {
              formatter: function(params){
                return
              }
            },
            data: lineHero.future_points
          })
        }
      })

      echartSeries.push({
        symbolSize: 16,
        symbol: 'circle',
        type: 'scatter',
        data: scatterData
      })

      var animationDuration = 1000

      if(thisApp.playSpeed > 2){
        animationDuration = 200
      }else if(thisApp.playSpeed > 1){
        animationDuration = 400
      }

      var echartOptions = {
        grid: {x: 43, y: 40, width: 615, height: 615},
        xAxis: {show: false, min: min.x, max: max.x},
        yAxis: {show: false, min: min.y, max: max.y},
        animation: true,
        animationDurationUpdate: animationDuration,
        title: {
          right: 25,
          bottom: 70,
          textStyle: {
            color: '#fff',
            fontSize: 30,
            textShadowColor: '#000',
            textShadowBlur: 1,
            textShadowOffsetX: 1,
            textShadowOffsetY: 1
          }
        },
        tooltip: {},
        series: echartSeries
      }

      var echartInstance = this.init_echart_instance();
      echartInstance.setOption(echartOptions, true)
    },
    get_team_color(team){
      if(team == "blue"){
        return "#2ad4e5"
      }else{
        return "#ff4848"
      }
    },
    init_game_buildings(gameInfo){

      var thisApp = this

      // 初始化游戏中所有的建筑 22座塔 6座水晶
      var buildings = [];

      buildings.push({
        name: "蓝色方 - 上外塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 981,
        point_y: 10441,
        team: "blue"
      })
      buildings.push({
        name: "蓝色方 - 中外塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 5846,
        point_y: 6396,
        team: "blue"
      })
      buildings.push({
        name: "蓝色方 - 下外塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 10504,
        point_y: 1029,
        team: "blue"
      })
      buildings.push({
        name: "蓝色方 - 上内塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 1512,
        point_y: 6699,
        team: "blue"
      })
      buildings.push({
        name: "蓝色方 - 中内塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 5048,
        point_y: 4812,
        team: "blue"
      })
      buildings.push({
        name: "蓝色方 - 下内塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 6919,
        point_y: 1483,
        team: "blue"
      })
      buildings.push({
        name: "蓝色方 - 上高塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 1169,
        point_y: 4287,
        team: "blue"
      })
      buildings.push({
        name: "蓝色方 - 中高塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 3651,
        point_y: 3696,
        team: "blue"
      })
      buildings.push({
        name: "蓝色方 - 下高塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 4281,
        point_y: 1253,
        team: "blue"
      })

      if(!gameInfo.ignore_inhibitor){
        buildings.push({
          name: "蓝色方 - 上水晶",
          building_type: "INHIBITOR_BUILDING",
          logo_url: this.static_url("/img/game_review/zb_inhibitor_blue_icon.png"),
          point_x: 1171,
          point_y: 3571,
          team: "blue"
        })
        buildings.push({
          name: "蓝色方 - 中水晶",
          building_type: "INHIBITOR_BUILDING",
          logo_url: this.static_url("/img/game_review/zb_inhibitor_blue_icon.png"),
          point_x: 3203,
          point_y: 3208,
          team: "blue"
        })
        buildings.push({
          name: "蓝色方 - 下水晶",
          building_type: "INHIBITOR_BUILDING",
          logo_url: this.static_url("/img/game_review/zb_inhibitor_blue_icon.png"),
          point_x: 3452,
          point_y: 1236,
          team: "blue"
        })
      }

      buildings.push({
        name: "蓝色方 - 上门牙塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 1748,
        point_y: 2270,
        team: "blue"
      })
      buildings.push({
        name: "蓝色方 - 下门牙塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_blue_icon.png"),
        point_x: 2177,
        point_y: 1807,
        team: "blue"
      })


      buildings.push({
        name: "红色方 - 上外塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 4318,
        point_y: 13875,
        team: "red"
      })
      buildings.push({
        name: "红色方 - 中外塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 8955,
        point_y: 8510,
        team: "red"
      })
      buildings.push({
        name: "红色方 - 下外塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 13866,
        point_y: 4505,
        team: "red"
      })
      buildings.push({
        name: "红色方 - 上内塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 7943,
        point_y: 13411,
        team: "red"
      })
      buildings.push({
        name: "红色方 - 中内塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 9767,
        point_y: 10113,
        team: "red"
      })
      buildings.push({
        name: "红色方 - 下内塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 13327,
        point_y: 8226,
        team: "red"
      })
      buildings.push({
        name: "红色方 - 上高塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 10481,
        point_y: 13650,
        team: "red"
      })
      buildings.push({
        name: "红色方 - 中高塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 11134,
        point_y: 11207,
        team: "red"
      })
      buildings.push({
        name: "红色方 - 下高塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 13624,
        point_y: 10572,
        team: "red"
      })

      if(!gameInfo.ignore_inhibitor){
        buildings.push({
          name: "红色方 - 上水晶",
          building_type: "INHIBITOR_BUILDING",
          logo_url: this.static_url("/img/game_review/zb_inhibitor_red_icon.png"),
          point_x: 11261,
          point_y: 13676,
          team: "red"
        })
        buildings.push({
          name: "红色方 - 中水晶",
          building_type: "INHIBITOR_BUILDING",
          logo_url: this.static_url("/img/game_review/zb_inhibitor_red_icon.png"),
          point_x: 11598,
          point_y: 11667,
          team: "red"
        })
        buildings.push({
          name: "红色方 - 下水晶",
          building_type: "INHIBITOR_BUILDING",
          logo_url: this.static_url("/img/game_review/zb_inhibitor_red_icon.png"),
          point_x: 13604,
          point_y: 11316,
          team: "red"
        })
      }

      buildings.push({
        name: "红色方 - 上门牙塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 12611,
        point_y: 13084,
        team: "red"
      })
      buildings.push({
        name: "红色方 - 下门牙塔",
        building_type: "TOWER_BUILDING",
        logo_url: this.static_url("/img/game_review/zb_tower_red_icon.png"),
        point_x: 13052,
        point_y: 12612,
        team: "red"
      })


      // 补充状态变化节点
      buildings.forEach(function(building){
        building.timeline = [{
          time: 0,
          status: "alive"
        }]
      })

      return buildings
    },
    process_game_wards(wardsData){

      var thisApp = this;

      var wards = []

      // 每个选手只能插一个控制守卫，插新的会消除旧的。这里维护每个选手最后的控制守卫ID
      var playerLastControlWards = {}

      wardsData.forEach(function(data){

        if(data.event_type==="WARD_PLACED"){

          // 忽略没有坐标的插眼数据
          //忽略未知眼
          if(data.point_x && data.point_y && data.eye_id){
            var ward = _.merge({}, data)

            var thisLogoUrl;

            if(ward.born_color===1){
              if(ward.eye_type==="YELLOW_TRINKET"){
                thisLogoUrl = thisApp.static_url("/img/game_review/blue_normalward_icon.png")
              }else if(ward.eye_type==="BLUE_TRINKET"){
                thisLogoUrl = thisApp.static_url("/img/game_review/blue_bluetrinket_icon.png")
              }else if(ward.eye_type==="SIGHT_WARD"){
                thisLogoUrl = thisApp.static_url("/img/game_review/blue_normalward_icon.png")
              }else if(ward.eye_type==="CONTROL_WARD"){
                thisLogoUrl = thisApp.static_url("/img/game_review/blue_sightward_icon.png")
              }else{
                thisLogoUrl = thisApp.static_url("/img/game_review/blue_undefined_icon.png")
              }
            }else{
              if(ward.eye_type==="YELLOW_TRINKET"){
                thisLogoUrl = thisApp.static_url("/img/game_review/red_normalward_icon.png")
              }else if(ward.eye_type==="BLUE_TRINKET"){
                thisLogoUrl = thisApp.static_url("/img/game_review/red_bluetrinket_icon.png")
              }else if(ward.eye_type==="SIGHT_WARD"){
                thisLogoUrl = thisApp.static_url("/img/game_review/red_normalward_icon.png")
              }else if(ward.eye_type==="CONTROL_WARD"){
                thisLogoUrl = thisApp.static_url("/img/game_review/red_sightward_icon.png")
              }else{
                thisLogoUrl = thisApp.static_url("/img/game_review/red_undefined_icon.png")
              }
            }

            ward.logo_url = thisLogoUrl

            ward.timeline = [
              {
                time: parseInt(data.event_time / 1000),
                status: "alive"
              },
              {
                time: parseInt((data.event_time + data.expire) / 1000),
                status: "dead"
              }
            ]

            if(ward.eye_type==="CONTROL_WARD"){

              var exControlWard = playerLastControlWards[ward.player_id]

              // 处理控制守卫选手唯一逻辑
              if(exControlWard){
                exControlWard.timeline.push({
                  time: parseInt(data.event_time / 1000),
                  status: "dead"
                })
              }

              playerLastControlWards[ward.player_id] = ward
            }

            wards.push(ward)
          }
        }else if(data.event_type==="WARD_KILL"){

          // 忽略无效的排眼数据
          var hiWard = lodash.find(wards, function(ward){
            return ward.eye_id === data.eye_id
          })

          if(hiWard){
            hiWard.timeline.push({
              time: parseInt(data.event_time / 1000),
              status: "dead"
            })
          }
        }

      })

      // 修正每个眼的timeline顺序
      wards.forEach(function(ward){
        var tmpTimeline = lodash.sortBy(ward.timeline, function(frame){
          return frame.time
        })
        ward.timeline = tmpTimeline
      })

      return wards
    },
    process_game_buildings(gameInfo, buildingsData){

      var buildings = this.init_game_buildings(gameInfo);

      // 补充摧毁时间
      buildingsData.forEach(function(data){
        var thisBuilding = lodash.find(buildings, function(building){
          return building.point_x === data.point_x && building.point_y === data.point_y
        })

        // console.info(data);

        if(thisBuilding){
          thisBuilding.timeline.push({
            time: parseInt(data.event_time / 1000),
            status: "dead"
          })
        }
      })

      return buildings
    },
    generate_cirle_hero_logo_canvas(imgUrl){
      var radius = 24
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.src = imgUrl;
      var cav = document.createElement('canvas');
      cav.width = radius * 2;
      cav.height = radius * 2;
      var context = cav.getContext('2d');
      context.clearRect(0, 0, radius * 2, radius * 2);
      img.onload = function(){
        context.save()
        context.beginPath()
        context.arc(radius, radius, radius, 0, 2* Math.PI); //画出圆
        context.clip(); //裁剪上面的圆形
        context.drawImage(img, 0, 0, radius * 2, radius * 2);
        context.restore(); // 还原状态
      }
      return cav
    },
    process_game_players(legsStat){

      var thisApp = this;

      var newPlayers = [];

      var gamePlayers = thisApp.game_players

      gamePlayers.forEach(function(player){

        var champion = dragontail.get_single_champion_info(player.championId, thisApp.champions)

        var newPlayer = {}
        newPlayer.player_id = player.originalAccountId
        newPlayer.game_name = player.summonerName
        newPlayer.team_id = player.teamId
        newPlayer.team_name = ""
        newPlayer.hero_id = player.championId
        newPlayer.part_id = player.participantId

        newPlayer.hero_logo = dragontail.generate_champion_logo_url(champion.id)
        newPlayer.hero_name = champion.name
        newPlayer.hero_title = champion.title
        newPlayer.duty_id = 0
        newPlayer.born_color = player.teamId == 200 ? 2 : 1
        newPlayer.timeline = []

        var playerCache = thisApp.gameInfo.playersCache[newPlayer.player_id]
        if(!playerCache){
          playerCache = {}
          playerCache.future_step = 1
          playerCache.history_step = 1
          playerCache.circle_logo = thisApp.generate_cirle_hero_logo_canvas(newPlayer.hero_logo)

          thisApp.gameInfo.playersCache[newPlayer.player_id] = playerCache
        }

        newPlayer.future_step = playerCache.future_step
        newPlayer.history_step = playerCache.history_step
        newPlayer.circle_logo = playerCache.circle_logo

        newPlayers.push(newPlayer)
      })

      return newPlayers
    },
    import_players_timeline(gameInfo, heroKillEvents, heroPositions){

      var thisApp = this;

      var hitPlayers = {}

      lodash.each(gameInfo.players, function(player){
        hitPlayers[player.part_id] = player
      })

      gameInfo.players.forEach(function(player){

        var playerDeadEvents = lodash.filter(heroKillEvents, function(event){
          return event.victim_id === player.part_id
        })

        var playerPositions = lodash.find(heroPositions, function(data){
          return data.hero_id === player.hero_id
        })

        var playerTimeline = []
        playerTimeline.push({
          time: 0,
          status: "alive"
        })

        if(playerDeadEvents && playerPositions){

          playerDeadEvents.forEach(function(deadEvent){

            var killer = hitPlayers[deadEvent.killer_id]

            var killerName

            if(killer){
              killerName = killer.game_name
            }

            // 通过killEvents确定死亡时间
            var deadTime = parseInt(deadEvent.event_time / 1000)

            playerTimeline.push({
              time: deadTime,
              status: "dead",
              killer_name: killerName
            })

            var aliveTime;

            // 再通过heroPositions的变动确认复活时间
            var deadPosIndex = parseInt(deadTime / playerPositions.interval)

            // 死亡取下一个坐标点
            deadPosIndex += 1

            var deadPosInfo = playerPositions.hot_point[deadPosIndex]

            if(deadPosInfo){
              // 往下寻找下一个坐标变动过的位置记录，计算复活时间
              for(var nextPosIndex = deadPosIndex+1; nextPosIndex < playerPositions.hot_point.length; nextPosIndex++){
                var nextPosInfo = playerPositions.hot_point[nextPosIndex]
                if(!nextPosInfo || nextPosInfo.axis_x!=deadPosInfo.axis_x || nextPosInfo.axis_y!=deadPosInfo.axis_y){
                  aliveTime = nextPosIndex * playerPositions.interval
                  break
                }
              }
            }

            if(aliveTime){
              playerTimeline.push({
                time: aliveTime,
                status: "alive"
              })
            }

          })
        }

        player.timeline = playerTimeline
      })
    },
    process_game_monsters(gameInfo, monstersData){

      var thisApp = this;

      var newMonstersData = []

      if(!monstersData){
        return newMonstersData
      }

      var gameDuration = gameInfo.duration

      // 峡谷先锋 09:50出现 19:45消失 不会刷新
      var riftHearldData = {
        key: "RIFTHERALD",
        point_x: 5050,
        point_y: 10430,
        logo_url: this.static_url("/img/game_review/zb_riftherald_icon.png"),
        timeline: [
          {
            time: 0,
            status: "dead"
          },
          {
            time: 9 * 60 + 50,
            status: "alive"
          }
        ]
      }

      // 男爵 20:00出现 7分钟刷新
      var baronData = {
        key: "BARON_NASHOR",
        name: "男爵",
        type: "BARON_NASHOR",
        point_x: 5050,
        point_y: 10440,
        logo_url: this.static_url("/img/game_review/zb_nashor_icon.png"),
        timeline: [
          {
            time: 0,
            status: "dead"
          },
          {
            time: 20 * 60,
            status: "alive"
          }
        ]
      }

      // 巨龙 02:20秒出现 死亡后6分钟刷新  29分钟后击杀的巨龙，刷新时间更改为8分钟
      var dragonData = {
        key: "DRAGON",
        name: "巨龙",
        type: "DRAGON",
        point_x: 9950,
        point_y: 4320,
        logo_url: this.static_url("/img/game_review/zb_dragon_icon.png"),
        timeline: [
          {
            time: 0,
            status: "dead"
          },
          {
            time: 2 * 60 + 20,
            status: "alive"
          }
        ]
      }

      // 红Buff 01:30出现，死亡后5分钟刷新
      var firstRedBuff = {
        key: "FIRST_RED_LIZARD",
        name: "红Buff",
        type: "RED_LIZARD",
        point_x: 7860,
        point_y: 4020,
        logo_url: this.static_url("/img/game_review/zb_jungle_icon.png"),
        timeline: [
          {
            time: 0,
            status: "dead"
          },
          {
            time: 1 * 60 + 30,
            status: "alive"
          }
        ]
      }

      var sceondRedBuff = {
        key: "SECOND_RED_LIZARD",
        name: "红Buff",
        type: "RED_LIZARD",
        point_x: 7170,
        point_y: 10850,
        logo_url: this.static_url("/img/game_review/zb_jungle_icon.png"),
        timeline: [
          {
            time: 0,
            status: "dead"
          },
          {
            time: 1 * 60 + 30,
            status: "alive"
          }
        ]
      }

      //蓝Buff 01:30出现，死亡后5分钟刷新
      var firstBlueBuff = {
        key: "FIRST_BLUE_GOLEM",
        name: "蓝Buff",
        type: "BLUE_GOLEM",
        point_x: 3750,
        point_y: 7930,
        logo_url: this.static_url("/img/game_review/zb_jungle_icon.png"),
        timeline: [
          {
            time: 0,
            status: "dead"
          },
          {
            time: 1 * 60 + 30,
            status: "alive"
          }
        ]
      }

      var secondBlueBuff = {
        key: "SECOND_BLUE_GOLEM",
        name: "蓝Buff",
        type: "BLUE_GOLEM",
        point_x: 11170,
        point_y: 6920,
        logo_url: this.static_url("/img/game_review/zb_jungle_icon.png"),

        timeline: [
          {
            time: 0,
            status: "dead"
          },
          {
            time: 1 * 60 + 30,
            status: "alive"
          }
        ]
      }

      // 记录是否存在红蓝buff击杀事件，否则忽略这两个野怪
      var findRedBuffKillEvent = false
      var findBlueBuffKillEvent = false
      monstersData.forEach(function(monsterData){

        if(!monsterData.point_x || !monsterData.point_y){
          return
        }

        var killerName
        if(monsterData.killer_id){

          var player = lodash.find(gameInfo.players, function(pl){
            return pl.part_id === monsterData.killer_id
          })

          var teamName = player.team_name

          killerName = "" + teamName + "." + player.game_name
        }else{
          var killerColor = monsterData.killer_color
          if(killerColor === 2){
            killerName = gameInfo.teams.red_team
          }else if(killerColor === 1){
            killerName = gameInfo.teams.blue_team
          }
        }

        if(!killerName){
          return
        }

        if(monsterData.monster_type==="RED_LIZARD"){
          findRedBuffKillEvent = true
          var killTime = parseInt(monsterData.event_time / 1000)
          var aliveTime = killTime + 5 * 60

          var thisMonster
          if(monsterData.point_y < 7000){
            thisMonster = firstRedBuff // 蓝色方
          }else{
            thisMonster = sceondRedBuff // 红色方
          }

          thisMonster.timeline.push({
            time: killTime,
            status: "dead",
            killer_name: killerName
          })

          // 下次刷新时间 5分钟后
          if(aliveTime < gameDuration){
            thisMonster.timeline.push({
              time: aliveTime,
              status: "alive"
            })
          }
        }

        if(monsterData.monster_type==="BLUE_GOLEM"){
          findBlueBuffKillEvent = true
          var killTime = parseInt(monsterData.event_time / 1000)
          var aliveTime = killTime + 5 * 60

          var thisMonster
          if(monsterData.point_x < 7000){
            thisMonster = firstBlueBuff // 蓝色方
          }else{
            thisMonster = secondBlueBuff // 红色方
          }

          thisMonster.timeline.push({
            time: killTime,
            status: "dead",
            killer_name: killerName
          })

          if(aliveTime < gameDuration){
            thisMonster.timeline.push({
              time: aliveTime,
              status: "alive"
            })
          }
        }

        if(monsterData.monster_type==="RIFTHERALD"){
          var killTime = parseInt(monsterData.event_time / 1000)

          var tmpTimeline = riftHearldData.timeline

          tmpTimeline.push({
            time: killTime,
            status: "dead",
            killer_name: killerName
          })

          riftHearldData.timeline = lodash.sortBy(tmpTimeline, function(frame){
            return frame.time
          })
        }

        if(monsterData.monster_type==="DRAGON"){
          var killTime = parseInt(monsterData.event_time / 1000)
          var aliveTime

          if(killTime < 29 * 60){
            aliveTime = killTime + 6 * 60
          }else{
            aliveTime = killTime + 8 * 60
          }

          dragonData.timeline.push({
            time: killTime,
            status: "dead",
            killer_name: killerName,
            killer_team_id: monsterData.killer_team_id,
            sub_type: monsterData.monster_sub_type
          })

          if(aliveTime < gameDuration){
            dragonData.timeline.push({
              time: aliveTime,
              status: "alive"
            })
          }
        }

        if(monsterData.monster_type==="BARON_NASHOR"){
          var killTime = parseInt(monsterData.event_time / 1000)
          var aliveTime = killTime + 7 * 60

          baronData.timeline.push({
            time: killTime,
            status: "dead",
            killer_name: killerName
          })

          if(aliveTime < gameDuration){
            baronData.timeline.push({
              time: aliveTime,
              status: "alive"
            })
          }
        }
      })

      // 峡谷先锋 19:45秒自动消失
      riftHearldData.timeline.push({
        time: 19 * 60 + 45,
        status: "dead",
        killer_name: "",
        auto_disappear: true
      })

      if(findRedBuffKillEvent){
        newMonstersData.push(firstRedBuff)
        newMonstersData.push(sceondRedBuff)
      }

      if(findBlueBuffKillEvent){
        newMonstersData.push(firstBlueBuff)
        newMonstersData.push(secondBlueBuff)
      }

      if(!gameInfo.ignore_riftherald){
        newMonstersData.push(riftHearldData)
      }

      newMonstersData.push(baronData)
      newMonstersData.push(dragonData)

      return newMonstersData
    },
    process_game_teams(){

      var newTeamInfo = {}
      newTeamInfo.blue_team = "Blue"
      newTeamInfo.red_team = "Red"
      newTeamInfo.blue_team_id = 100
      newTeamInfo.red_team_id = 200

      return newTeamInfo
    },
    import_teams_gold_timeline(gameInfo, heroEconomy){

      var thisApp = this;

      var blueTeamGoldTimeline = []
      blueTeamGoldTimeline.push({
        time: 0,
        gold: 2500
      })

      var redTeamGoldTimeline = []
      redTeamGoldTimeline.push({
        time: 0,
        gold: 2500
      })

      if(heroEconomy){
        var heros = lodash.filter(lodash.values(heroEconomy), function(data){
          return data != null
        })

        if(heros.length){
          var firstHero = lodash.head(heros)
          var nodeCount = firstHero.money_count
          var nodeInterval = firstHero.interval || 5

          var blueTeamHeros = lodash.filter(heros, function(hero){
            return hero.team_id === gameInfo.teams.blue_team_id
          })


          var redTeamHeros = lodash.filter(heros, function(hero){
            return hero.team_id === gameInfo.teams.red_team_id
          })

          for(var nodeIndex = 0; nodeIndex < nodeCount; nodeIndex++){
            var blueTmpGold = lodash.reduce(blueTeamHeros, function(sum, hero){
              var gold = hero.money_list[nodeIndex]
              if(gold){
                return sum + parseInt(gold)
              }else{
                return sum
              }
            }, 0);
            var redTmpGold = lodash.reduce(redTeamHeros, function(sum, hero){
              var gold = hero.money_list[nodeIndex]
              if(gold){
                return sum + parseInt(gold)
              }else{
                return sum
              }
            }, 0);


            var firstIndex = nodeIndex

            var tmpTime = firstIndex * nodeInterval

            blueTeamGoldTimeline.push({
              time: tmpTime,
              gold: blueTmpGold
            })

            redTeamGoldTimeline.push({
              time: tmpTime,
              gold: redTmpGold
            })
          }
        }
      }

      gameInfo.teams.blue_team_gold_timeline = blueTeamGoldTimeline
      gameInfo.teams.red_team_gold_timeline = redTeamGoldTimeline
    },
    import_game_info(){

      var thisApp = this;

      thisApp.update_game_data(thisApp.legs)

      thisApp.isLoadingGameInfo = false;
      thisApp.gameInfoLoadingError = "";

    },
    update_game_data(legs){

      var thisApp = this

      var newGameInfo = {}

      newGameInfo.ignore_inhibitor = false
      newGameInfo.ignore_riftherald = false


      newGameInfo.data_type = "riot";
      newGameInfo.duration = LegsStatReader.get_game_duration(legs.stat)

      newGameInfo.players = thisApp.process_game_players(legs.stat);
      newGameInfo.teams = thisApp.process_game_teams();

      var generateHeroPositions = GameReplayDataLoader.generate_hero_positions(legs.stat, legs.timeline)

      var heroPositions = lodash.filter(lodash.values(generateHeroPositions), function(data){
        return data != null
      });

      var heroKillEvents = GameReplayDataLoader.generate_hero_kill_events(legs.stat, legs.timeline)

      thisApp.import_players_timeline(newGameInfo, heroKillEvents, heroPositions);

      var heroEconomy = GameReplayDataLoader.generate_hero_economy(legs.stat, legs.timeline)

      thisApp.import_teams_gold_timeline(newGameInfo, heroEconomy)

      newGameInfo.heroPositions = heroPositions
      newGameInfo.heroKillEvents = heroKillEvents

      var buildingsData = GameReplayDataLoader.generate_buildings_data(legs.stat, legs.timeline)

      newGameInfo.buildings = thisApp.process_game_buildings(newGameInfo, buildingsData);

      var monstersData = GameReplayDataLoader.generate_monsters_data(legs.stat, legs.timeline)
      newGameInfo.monsters = thisApp.process_game_monsters(newGameInfo, monstersData);

      var wardsData = GameReplayDataLoader.generate_wards_data(legs.stat, legs.timeline)
      newGameInfo.wards = thisApp.process_game_wards(wardsData);

      // 一次性更新gameInfo
      thisApp.gameInfo = newGameInfo

      thisApp.timeline.total = newGameInfo.duration;

      newGameInfo = null
    },
    fetch_game_events(){
      var apiPath = this.generate_api_path("game_events");
      var game_id = this.settings.game_id

      var token = this.settings.api.token

      var apiParams = {
        token: token,
        game: game_id
      }

      return axios.get(apiPath, {params: apiParams});
    },
    format_game_time (seconds) {

      var minutes = parseInt(seconds / 60);
      var tailSeconds = parseInt(seconds % 60);

      var fMin, fSec;

      if(minutes < 10) {
        fMin = "0" + minutes
      }else{
        fMin = "" + minutes
      }

      if(tailSeconds < 10) {
        fSec = "0" + tailSeconds
      }else{
        fSec = "" + tailSeconds
      }

      return fMin + ":" + fSec
    },
    init_timeline () {
      if(!this.timeline_instance){
        var thisChart = echarts.init(this.$refs.timeline)

        var thisApp = this
        thisChart.on('dataZoom', function (params) {

          thisApp.temp_pause_player()

          if (thisApp.timeline.current !== parseInt(params.start * thisApp.timeline.total / 100) || thisApp.end !== parseInt(params.end * thisApp.timeline.total / 100)) {
            thisApp.timeline.current = parseInt(params.start * thisApp.timeline.total / 100)
            thisApp.timeline.current = parseInt(params.end * thisApp.timeline.total / 100)
          }
        })

        this.timeline_instance = thisChart
      }
      return this.timeline_instance
    },
    temp_pause_player(){
      // 暂停自动播放
      autoPlayerPause = true

      if(pauseTimer){
        clearTimeout(pauseTimer)
      }

      // 1秒后恢复
      pauseTimer = setTimeout(function(){
        autoPlayerPause = false
      }, 1000)

    },
    draw_timeline () {

      var datatime = [[0, 2]]
      var option2 = {
        grid: {
          show: false,
          containLabel: false
        },
        xAxis: {
          min: 0,
          max: this.timeline.total,
          type: 'value',
          show: false,
          splitLine: {show: false},
          axisLine: {onZero: false}
        },
        yAxis: {
          min: 0,
          max: 1,
          show: false,
          type: 'value',
          splitLine: {show: false},
          axisLine: {onZero: false}
        },
        dataZoom: [

          {
            id: 'dataZoomX',
            type: 'slider',
            height: 8,
            filterMode: 'none',
            fillerColor: '#ff9707',
            borderColor: '#595959',
            backgroundColor: '#595959',
            handleIcon: "image://" + this.static_url("/img/game_review/btn_slider.png"),
            dataBackground: {
              lineStyle: {
                color: '#595959',
                width: 0
              },
              areaStyle: {
                color: '#595959',
                width: 0
              }
            },
            startValue: this.timeline.current,
            endValue: this.timeline.current,
            textStyle: false,
            zoomLock: true,
            left: 10,
            right: 10,
            top: 14,
            handleSize: 20,
            handleStyle: {
              borderColor: '#ffffff',
              borderWith: 1,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              shadowBlur: 10
            }
          }
        ],
        series: [
          {
            id: 'a',
            type: 'line',
            smooth: false,
            data: datatime
          }
        ]
      }
      var chart2 = this.init_timeline()
      chart2.setOption(option2, true)
    },
    getDefaultSettings(){
      var retVal = {
        api: {
          // root: "https://data.pentaq.com",
          root: "http://data.pentaq.ltd",
          token: "611|923f991dbd1a8792af87664aacbf72645ccd41bd8f1f68b1dde3b25033aa4275",
          // root: "//data.pentaq.ltd",
          // token: "611|a72103d8dbbd4703ab523ce85a633f679c6ad00530b34678a96d163e34b48f88",
          game_events: "/admin/riot_stream/riot_game_replay_events_data_api"
        },
        static_root: "/static",
        app_version: "",
        tour_id: 59,
        filter_id: null,
        team_id: 129,
        game_id: 1120717,
        playSpeed: 5,
        language: "cn",
        mode: "tour_stat", //tour_stat 指赛事数据查询系统， training_system 指训练赛系统
        training_system_battle_id: 1416901,
        training_system_world_id: 1281,
        auto_refresh: false
      }

      return retVal
    },
    loadSettings(){
      var defaultConfig = this.getDefaultSettings()
      var propConfig = this.config
      return lodash.merge({}, defaultConfig, propConfig)
    },
    generate_api_path(apiName){

      var path = this.settings.api[apiName];

      return "" + this.settings.api.root + path;
    },
    static_root: function(){
      return this.settings.static_root;
    },
    static_url: function(path){
      if(!path){
        return
      }
      return this.static_root() + path + "?v=" + this.settings.app_version
    },
    generateWardToolTipHtml: function(data){

      var thisApp = this;

      var teamColor;
      if(data.born_color===1){
        teamColor = thisApp.get_team_color("blue");
      }else{
        teamColor = thisApp.get_team_color("red");
      }

      var tpl = this.$refs.tooltipTpl.innerHTML;

      var html = template(tpl, {
        logo: data.hero_logo,
        color: teamColor,
        title: data.player_name,
        content: "于 " + data.event_time +" 插下 " + data.wards_name
      })

      return html
    },
    generateCommonToolTipHtml: function(data){
      var tpl = this.$refs.tooltipTpl.innerHTML;
      var html = template(tpl, data)
      return html
    },
    generateDefaultGameInfo: function(){
      return {
        duration: 0,
        buildings: [],
        goldOffsets: [],
        heroPositions: [],
        heroKillEvents: [],
        monsters: [],
        players: [],
        teams: [],
        wards: [],
        ignore_inhibitor: false,
        ignore_riftherald: false,
        playersCache: {},
      }
    }
  }
}

</script>


<style scoped>

  .game-review {
    position: relative;
    width: 800px;
    margin: auto;
    background: #fff;
    border: solid 1px #e7e7e7;
    padding: 10px 0;
    border-radius: 5px;
  }

  .tp_container {
    position: relative;
    width: 700px;
    float: left;
    margin-left: 50px;
  }

  .blue-team-player {
    width: 250px;
    float: left;
    height: 700px;
  }
  .team-hero-box {
    width: 150px;
    margin: auto;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    background: #f7f7f7;
    padding: 20px 0;
  }

  .red-team-player {
    width: 250px;
    float: left;
  }

  .tp_map {
    position: relative;
    display: block;
    width: 700px;
    height: 700px;
  }
  .tp_map .tp_map_img {
    width: 100%;
    height: 100%;
  }
  .tp_echart_wrap {
    width: 700px;
    height: 700px;
    position: absolute;
    left: 0;
    top: 0;
  }

  .tp_timeline {
    width: 570px;
    height: 35px;
    position: absolute;
    left: 35px;
    z-index: 9;
  }

  .tp_item {
    display: block;
    position: absolute;
    font-size: 14px;
    color: black;
    line-height: 100%;
    top: 12px;
  }

  .tp_loading_wrap {
    z-index: 100;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.8);
  }

  .tp_loading_wrap .tp_centerbox {
    width: 500px;
    height: 250px;
    margin: 0 auto;
    margin-top: 250px;
    position: relative;
  }

  .tp_loading_wrap img {
    display: block;
    height: 100px;
    width: 160px;
    margin: 0 auto;
  }


  .tp_game_score_line {
    display: block;
    width: 594px;
    height: 40px;
    position: absolute;
    margin-left: -297px;
    left: 50%;
    top: 0;
    font-size: 14px;
  }

  .tp_team_name {
    position: absolute;
    top: 0;
    text-align: center;
    width: 60px;
    height: 30px;
    line-height: 30px
  }
  .tp_blue_team_name {
    left: 0;
    color: #1fb8ff;
  }
  .tp_red_team_name {
    right: 0;
    color: #ff5757;
  }

  .tp_tower {
    position: absolute;
    height: 20px;
    line-height: 20px;
  }
  .tp_tower_blue {
    color: #1fb8ff;
    left: 90px;
    top: 10px;
  }

  .tp_tower_red {
    color: #ff5757;
    left: 465px;
    top: 10px;
  }

  .tp_tower_img {
    height: 20px;
    width: 20px;
    vertical-align: top;
  }
  .tp_tower_num {
    margin-left: 4px;
  }

  .tp_gold {
    position: absolute;
    height: 20px;
    line-height: 20px;
  }
  .tp_gold_blue {
    color: #1fb8ff;
    left: 145px;
    top: 10px;
  }
  .tp_gold_red {
    color: #ff5757;
    left: 385px;
    top: 10px;
  }

  .tp_gold_img {
    height: 20px;
    width: 20px;
    vertical-align: top;
  }
  .tp_gold_num {
    margin-left: 4px;
  }
  .tp_game_score {
    width: 130px;
    height: 20px;
    line-height: 20px;
    position: absolute;
    left: 232px;
    top: 10px;
  }
  .tp_score_blue {
    color: #1fb8ff;
    font-size: 20px;
    font-weight: bold;
    position: absolute;
    right: 88px;
    width: 24px;
    text-align: center;
  }
  .tp_score_red {
    color: #ff5757;
    font-size: 20px;
    font-weight: bold;
    left: 88px;
    position: absolute;
    width: 24px;
    text-align: center;
  }
  .tp_score_img {
    vertical-align: top;
    left: 55px;
    position: absolute;
  }

  .tp_game_time {
    position: absolute;
    top: 46px;
    left: 330px;
    font-size: 16px;
    color: white;
    line-height: 16px;
    height: 16px;
  }

  .tp_dragons_blue {
    position: absolute;
    top: 44px;
    right: 415px;
  }
  .tp_dragons_red {
    position: absolute;
    top: 44px;
    left: 415px;
  }

  .tp_dragon_img {
    width: 20px;
    height: 20px;
    float: right;
  }

  .tp_dragons_red .tp_dragon_img {
    float: left;
  }

  .review-title {
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }

  .slider-box {
    margin-top: 10px;
    height: 35px;
    width: 700px;
    position: relative;
    background: #7f7f7f;
    border-radius: 3px;
    box-shadow: inset 4px 4px 10px rgba(255, 255, 255, 0.4);
  }

  .play-btn {
    font-size: 20px;
    cursor: pointer;
    color: white;
    vertical-align: middle;
  }

  .hero-icon-team {
    display: inline-block;
    width: 70px;
    height: 70px;
  }

  .blue-bor {
    display: inline-block;
    width: 70px;
    height: 70px;
    border: 3px solid #78b4ff;
    text-align: center;
    margin-top: 19px;
  }

  .red-bor {
    display: inline-block;
    width: 70px;
    height: 70px;
    border: 3px solid #be4a55;
    text-align: center;
    margin-top: 19px;
  }

  .player-name {
    font-size: 14px;
    font-weight: bold;
    line-height: 30px;
  }

  .clearfix {
    clear: both;
  }

</style>
